// extracted by mini-css-extract-plugin
module.exports = {"item-container":"mochi-parking-tutorial-carousel_item-container__oXetx","item-content":"mochi-parking-tutorial-carousel_item-content__tabn5"};